const config = {
  PREMIUM_TIER_ENABLED: import.meta.env.VITE_PREMIUM_TIER_ENABLED === 'true',
  LIVE_TIER_ENABLED: import.meta.env.VITE_LIVE_TIER_ENABLED === 'true',
  USERPAGES_URL: import.meta.env.VITE_USERPAGES_URL,
  WEBSOCKET: import.meta.env.VITE_WEBSOCKET,
  AUTH_URL: import.meta.env.VITE_AUTH_URL,
};

export default config;
